import app from 'Cloud/Application/app';
import { setNewUser } from 'reactApp/modules/user/user.actions';
import { store } from 'reactApp/store';

app.on('page:start', () => {
    if (!app.isPublic() && app.user.isNewbie()) {
        store.dispatch(setNewUser());
    }
});
